module.exports = __webpack_public_path__ + "static/media/1013201.9b525eb6.png";